export default "images/组 53.png";